import {
    createCombinedReducer,
    createModuleFactory,
    IModuleFactory,
} from '@omaze/redux';
import { Reducer } from 'redux';

import { createTooltipAddReducer } from './actions/add-tooltip-message/AddTooltipMessage';
import { createTooltipRemoveReducer } from './actions/remove-tooltip-message/RemoveTooltipMessage';
import { ITooltipState, TOOLTIP_NAMESPACE } from './Tooltip.state';

const initialState: ITooltipState = {
    message: null,
};

const tooltipReducer: Reducer<ITooltipState> = createCombinedReducer<ITooltipState>([
    createTooltipAddReducer,
    createTooltipRemoveReducer,
], initialState);

export const getTooltipModule: IModuleFactory = createModuleFactory<ITooltipState>(TOOLTIP_NAMESPACE, tooltipReducer);
